import React, { FC, useCallback, useState } from 'react'
import styles from 'styles/components/calendar.module.scss'
import text from 'styles/utility/text.module.scss'
import { ScheduleCalendar, ScheduleLabel, ScheduleArrowButton } from 'components/Calendar'
import { Spacer } from 'components/Utility'
import { Card, CardInner } from 'components/Card'
import { Balloon } from 'components/Balloon'
import { FlexColumn } from 'components/Flex'
import { BlueButton, SelectDaysOfWeekButton } from 'components/Button'
import { DaysOfWeekPicker } from 'components/Form'
import { CautionModal } from 'components/Modal'
import { DayOfWeekType } from 'lib/daysOfWeek'

type Props = {
  activeDates: Date[]
  businessDays: DayOfWeekType[]
  currentMonth: Date
  daysOfWeek: DayOfWeekType[]
  handleCurrentMonth: (date: Date) => void
  individualSettingDates: Date[]
  selectAllDateByDaysOfWeek: () => void
  selectAllDaysOfWeek: () => void
  selectDate: (date: Date) => void
  selectDaysOfWeek: (dayOfWeek: DayOfWeekType) => void
  unselectAllDaysOfWeek: () => void
}

const ScheduleCalendarContainer: FC<Props> = (props) => {
  const {
    activeDates,
    businessDays,
    currentMonth,
    daysOfWeek,
    handleCurrentMonth,
    individualSettingDates,
    selectAllDateByDaysOfWeek,
    selectAllDaysOfWeek,
    selectDate,
    selectDaysOfWeek,
    unselectAllDaysOfWeek,
  } = props

  const [open, setOpen] = useState<boolean>(false)
  const openModal = useCallback(() => setOpen(true), [setOpen])
  const closeModal = useCallback(() => setOpen(false), [setOpen])

  return (
    <>
      <Card>
        <CardInner>
          <div className={styles.calendar__monthly__header}>
            <ScheduleArrowButton
              currentMonth={currentMonth}
              handleCurrentMonth={handleCurrentMonth}
              label={'前月'}
              type={'prev'}
            />
            <ScheduleLabel currentMonth={currentMonth} />
            <ScheduleArrowButton
              currentMonth={currentMonth}
              handleCurrentMonth={handleCurrentMonth}
              label={'翌月'}
              type={'next'}
            />
          </div>
          <Spacer size={16} />
          <ScheduleCalendar
            activeDates={activeDates}
            businessDays={businessDays}
            currentMonth={currentMonth}
            individualSettingDates={individualSettingDates}
            selectDate={selectDate}
          />
          <Spacer size={17} />
          <Balloon direction={'top'}>
            <FlexColumn alignItems={'center'}>
              <p className={`${text.font_bold} ${text.font_medium} ${text.align_center}`}>
                曜日を選択して現在の表示月に一括反映
              </p>
              <Spacer size={16} />
              <SelectDaysOfWeekButton
                daysOfWeek={daysOfWeek}
                unselectAll={unselectAllDaysOfWeek}
                selectAll={selectAllDaysOfWeek}
              />
              <Spacer size={16} />
              <DaysOfWeekPicker
                selectableDaysOfWeek={businessDays}
                daysOfWeek={daysOfWeek}
                selectDaysOfWeek={selectDaysOfWeek}
                wrap={true}
              />
              <Spacer size={16} />
              <BlueButton
                disabled={daysOfWeek.length === 0}
                label={'カレンダーに反映'}
                onClick={openModal}
                size={'medium'}
                type={'outlined'}
              />
            </FlexColumn>
          </Balloon>
        </CardInner>
      </Card>
      <CautionModal
        actionLabel={'設定する'}
        cancelLabel={'キャンセル'}
        caution={'一括設定'}
        description={'設定済の日程は、上書きされますがよろしいですか？'}
        closeModal={closeModal}
        open={open}
        onClickAction={() => {
          selectAllDateByDaysOfWeek()
          closeModal()
        }}
        onClickCancel={closeModal}
      />
    </>
  )
}

export default ScheduleCalendarContainer
